module.exports = "Optimize or resize the image is desired"


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/PhotoEditor/photo-editor-how-to-step-three.md
// module id = 1166
// module chunks = 0